import { cn } from "@/lib/utils";

const PlayIcon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden
    viewBox="0 0 24 24"
    fill="currentColor"
    className={cn("h-6 w-6", className)}
  >
    <path d="M9 6.6c0-1 1.05-1.55 1.85-1L18.4 11c.75.5.75 1.55 0 2.05l-7.55 5.4c-.8.55-1.85 0-1.85-1V6.6Z" />
  </svg>
);

export default PlayIcon;
